<template>
  <div id="app">
    <div class="navbar-container container-fluid">
    <nav class="navbar" v-if="authStore.isAuthenticated">
      <div class="navbar-brand">
        <h1>11ecom FeedMaster</h1>
        <span class="navbar-subtitle">Mirakl-Billbee Synchronisation</span>
      </div>
      
      <div class="navbar-nav flex-row">
        <router-link to="/" class="nav-link" active-class="active">Dashboard</router-link>
        <router-link to="/orders" class="nav-link" active-class="active">Orders</router-link>
        <router-link to="/datev-report" class="nav-link" active-class="active">DATEV Report</router-link>
        <router-link to="/products" class="nav-link" active-class="active">Products</router-link>
        <router-link to="/tasks" class="nav-link" active-class="active">Tasks</router-link>
        <router-link to="/logs" class="nav-link" active-class="active">Logs</router-link>
      </div>
      
      <div class="navbar-status">
        <sync-status />
      </div>

      <div class="navbar-user">
        <span class="navbar-user-name">{{ authStore.displayName }}</span>
        <button class="btn btn-outline btn-sm" type="button" @click="logout">
          Logout
        </button>
      </div>
    </nav>
    </div>
    <main class="main-content" :class="{ 'main-content-auth': !authStore.isAuthenticated }">
      <router-view />
    </main>

    <footer class="footer" v-if="authStore.isAuthenticated">
      <p>&copy; 2026 ElevenAdmin - FeedMaster v1.0</p>
    </footer>
  </div>
</template>

<script>
import SyncStatus from './components/SyncStatus.vue'
import { useAuthStore } from '@/stores/authStore'

export default {
  name: 'App',
  components: {
    SyncStatus
  },
  computed: {
    authStore() {
      return useAuthStore()
    }
  },
  methods: {
    async logout() {
      await this.authStore.logout()
      await this.$router.replace({ name: 'Login' })
    }
  }
}
</script>

<style scoped>


.navbar-subtitle {
  font-size: 0.8rem;
  opacity: 0.8;
  display: block;
}

.navbar-nav {
  display: flex;
  gap: 2rem;
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.navbar-user-name {
  font-size: 0.9rem;
  font-weight: 600;
}

.nav-link {
  
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.nav-link:hover,
.nav-link.active {
  background-color: rgba(77, 77, 77, 0.2);
}

.main-content {
  min-height: calc(100vh - 140px);
  padding: 2rem;
}

.main-content-auth {
  min-height: 100vh;
  padding: 0;
}

.footer {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  color: #6c757d;
}
</style>
